<div>
  <app-erbo-header></app-erbo-header>
  <app-landing-view id="landing"></app-landing-view>
  <app-offering id="offering"></app-offering>
  <app-philosophy id="philosophy"></app-philosophy>
  <app-contact id="contact"></app-contact>
  <app-footer></app-footer>
</div>
